import { ProductService } from 'src/services/product.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const PRODUCT_NEW_CARE_SUCCESS = 'PRODUCT:NEW_CARE_SUCCESS'
export const PRODUCT_LIST_SUCCESS = 'PRODUCT:FIND_ALL_SUCCESS'
export const PRODUCT_LIST_FAILD = 'PRODUCT:FIND_ALL_FAILD'
export const PRODUCT_COUNT_ASSIGN_SUCCESS = 'PRODUCT:COUNT_ASSIGN_SUCCESS'
export const PRODUCT_COUNT_ASSIGN_FAILD = 'PRODUCT:COUNT_ASSIGN_FAILD'

export const PRODUCT_CREATE_SUCCESS = 'PRODUCT:CREATE_SUCCESS'
export const PRODUCT_CREATE_FAILD = 'PRODUCT:CREATE_FAILD'

export const PRODUCT_IMPORT_SUCCESS = 'PRODUCT:IMPORT_SUCCESS'
export const PRODUCT_SAVE_SUCCESS = 'PRODUCT:SAVE_SUCCESS'
export const PRODUCT_SAVE_FAILD = 'PRODUCT:SAVE_SUCCESS'

export const PRODUCT_DEL_SUCCESS = 'PRODUCT:DEL_SUCCESS'
export const PRODUCT_DEL_FAILD = 'PRODUCT:DEL_FAILD'

export const PRODUCT_ONE_SUCCESS = 'PRODUCT:FIND_ONE_SUCCESS'
export const PRODUCT_ONE_FAILD = 'PRODUCT:FIND_ONE_FAILD'

export const PRODUCT_HISTORY_LIST_SUCCESS = 'PRODUCT:HISTORY_FIND_ALL_SUCCESS'
export const PRODUCT_HISTORY_LIST_FAILD = 'PRODUCT:HISTORY_FIND_ALL_FAILD'

export const PRODUCT_UPDATE_FILTER = 'PRODUCT:UPDATE_FILTER'

export const PRODUCT_ORDER_SUCCESS = 'PRODUCT:ORDER_SUCCESS'
export const PRODUCT_ORDER_FAILD = 'PRODUCT:ORDER_FAILD'

export const PRODUCT_UPDATE_HOMEPAGE_FILTER = 'PRODUCT:PRODUCT_UPDATE_HOMEPAGE_FILTER'

export const PRODUCT_HOMEPAGE_LIST_SUCCESS = 'PRODUCT:FIND_HOMEPAGE_LIST_SUCCESS'
export const PRODUCT_HOMEPAGE_LIST_FAILD = 'PRODUCT:FIND_HOMEPAGE_LIST_FAILD'

export const PRODUCT_HOMEPAGE_ONE_SUCCESS = 'PRODUCT:FIND_HOMEPAGE_ONE_SUCCESS'
export const PRODUCT_HOMEPAGE_ONE_FAILD = 'PRODUCT:FIND_HOMEPAGE_ONE_FAILD'

export const PRODUCT_LIMIT_UPDATE_HOMEPAGE_FILTER = 'PRODUCT:PRODUCT_LIMIT_UPDATE_HOMEPAGE_FILTER'

export const PRODUCT_LIMIT_HOMEPAGE_LIST_SUCCESS = 'PRODUCT:LIMIT_FIND_HOMEPAGE_LIST_SUCCESS'
export const PRODUCT_LIMIT_HOMEPAGE_LIST_FAILD = 'PRODUCT:LIMIT_FIND_HOMEPAGE_LIST_FAILD'

export const PRODUCT_LIMIT_HOMEPAGE_ONE_SUCCESS = 'PRODUCT:LIMIT_FIND_HOMEPAGE_ONE_SUCCESS'
export const PRODUCT_LIMIT_HOMEPAGE_ONE_FAILD = 'PRODUCT:LIMIT_FIND_HOMEPAGE_ONE_FAILD'

export const ProductAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    setTrangThai,
    updateFilter,

    homepageList,
    updateHomepageFilter,
    homepageFindOne,

    homepageLimitList,
    updateHomepageLimitFilter,
    homepageLimitFindOne,

    sendOrder,
}

function updateHomepageFilter(payload) {
    return { type: PRODUCT_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { product } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageProductFilter } = product;
        const homepageProductPage = homepageProductFilter.homepageProductPage;
        const homepageProductLimit = homepageProductFilter.homepageProductLimit;

        return new Promise((resolve, reject) => {
            ProductService.homepageList(homepageProductFilter).then((rs) => {
                if (!!homepageProductFilter && homepageProductFilter.homepageProductPage === 0) {
                    dispatch(success({
                        homepageProductItems: rs.data.values,
                        homepageProductTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = product.homepageProductItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageProductLimit * homepageProductPage; i < homepageProductLimit * homepageProductPage + homepageProductLimit; i++) {
                        if (typeof rsDataValues[i - homepageProductLimit * homepageProductPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageProductLimit * homepageProductPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageProductItems: uniqueItems,
                        homepageProductTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: PRODUCT_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        ProductService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: PRODUCT_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_HOMEPAGE_ONE_FAILD, error } }
}

function updateHomepageLimitFilter(payload) {
    return { type: PRODUCT_LIMIT_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageLimitList() {
    return (dispatch, getState) => {
        const { product } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageProductLimitFilter } = product;
        const homepageProductLimitPage = homepageProductLimitFilter.homepageProductLimitPage;
        const homepageProductLimitLimit = homepageProductLimitFilter.homepageProductLimitLimit;

        return new Promise((resolve, reject) => {
            ProductService.homepageLimitList(homepageProductLimitFilter).then((rs) => {
                if (!!homepageProductLimitFilter && homepageProductLimitFilter.homepageProductLimitPage === 0) {
                    dispatch(success({
                        homepageProductLimitItems: rs.data.values,
                        homepageProductLimitTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = product.homepageProductLimitItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageProductLimitLimit * homepageProductLimitPage; i < homepageProductLimitLimit * homepageProductLimitPage + homepageProductLimitLimit; i++) {
                        if (typeof rsDataValues[i - homepageProductLimitLimit * homepageProductLimitPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageProductLimitLimit * homepageProductLimitPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageProductLimitItems: uniqueItems,
                        homepageProductLimitTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: PRODUCT_LIMIT_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_LIMIT_HOMEPAGE_LIST_FAILD, error } }
}

function homepageLimitFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        ProductService.homepageLimitFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: PRODUCT_LIMIT_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_LIMIT_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: PRODUCT_UPDATE_FILTER, data: payload }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            ProductService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(ProductAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: PRODUCT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_CREATE_FAILD, error } }
}

function setTrangThai(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            ProductService.setTrangThai(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(ProductAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: PRODUCT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        ProductService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: PRODUCT_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { product } = getState()
        dispatch(AppAction.appLoading(true));
        ProductService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...product.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: PRODUCT_LIST_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { product } = getState();
        const page = product && typeof product.filter !== 'undefined' && product.filter && typeof product.filter.page !== 'undefined' ? product.filter.page : 0;
        const limit = product && typeof product.filter !== 'undefined' && product.filter && typeof product.filter.limit !== 'undefined' ? product.filter.limit : 10;
        
        return new Promise((resolve, reject) => {
            ProductService.findAll(page, limit, product.filter).then((rs) => {
                if (page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count
                    }));
                    
                    resolve(rs);
                } else {
                    const oldItems = product.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count
                    }));

                    resolve(rs);
                }
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: PRODUCT_LIST_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: PRODUCT_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            ProductService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(ProductAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: PRODUCT_SAVE_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            ProductService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(ProductAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
                alert("Không thể tạo, có thể do trùng tên sản phẩm trước đó!");
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: PRODUCT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ProductService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(ProductAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: PRODUCT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ProductService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(ProductAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: PRODUCT_DEL_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ProductService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: PRODUCT_ONE_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ProductService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(ProductAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { product } = getState()
        dispatch(AppAction.appLoading(true));
        ProductService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...product.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: PRODUCT_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        ProductService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt này do hiện tại đang tạm hết hàng. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: PRODUCT_ORDER_SUCCESS, data } }
    function failure(error) { return { type: PRODUCT_ORDER_FAILD, error } }
}